module.exports = __webpack_public_path__ + "img/not-found.cba7fb68.svg";